module.exports = __webpack_public_path__ + "img/1329713320.8e099606.jpg";